import { render, staticRenderFns } from "./input-checkbox.vue?vue&type=template&id=a9819bcc"
import script from "./input-checkbox.vue?vue&type=script&lang=js"
export * from "./input-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@coac/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports